import { gql } from '@apollo/client'

export const DESTROY_CUSTOMER_SQUARE_CARD = gql`
  mutation DestroyCustomerSquareCard($input: DestroyCustomerSquareCardInput!) {
    destroyCustomerSquareCard(input: $input) {
      customerSquareCard {
        id
      }
    }
  }
`
